import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Booking from './Booking';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

function BookingPage() {
  const { id } = useParams();
  const [accommodation, setAccommodation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [bookedDates, setBookedDates] = useState({});

  useEffect(() => {
    fetch(`${BASE_URL}/api/accommodations/${id}`)
      .then((response) => response.json())
      .then((data) => {
        setAccommodation(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching accommodation:', error);
        setLoading(false);
      });
  }, [id]);

  const handleBookingConfirm = (bookingDetails) => {
    console.log('Booking confirmed:', bookingDetails);
    const accommodationId = bookingDetails.accommodationId;
    const newBookedDates = { ...bookedDates };
    if (!newBookedDates[accommodationId]) {
      newBookedDates[accommodationId] = [];
    }
    const dates = [];
    let currentDate = bookingDetails.checkInDate;
    while (currentDate <= bookingDetails.checkOutDate) {
      dates.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }
    newBookedDates[accommodationId] = [...newBookedDates[accommodationId], ...dates];
    setBookedDates(newBookedDates);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!accommodation) {
    return <div>Accommodation not found.</div>;
  }

  return (
    <Booking
      accommodation={accommodation}
      onBookingConfirm={handleBookingConfirm}
      bookedDates={bookedDates[accommodation.id] || []}
    />
  );
}

export default BookingPage;
